import strings from 'utils/strings'
import { MAX_MODULE_COUNTS } from 'utils/constants'
import displayModuleName from 'i18n/displayConstants/displayModuleName'

export const tooManyResources = (
  record,
  isOverQueryCount,
  isOverTimerCount,
  moduleCapacity = {}
) => {
  if (!isOverQueryCount && !isOverTimerCount) return false

  const { moduleName, moduleType, latestOnVehicle, isMarkedForDeletion } =
    record
  const displayName = displayModuleName(moduleName)
  const canUpgrade = !latestOnVehicle && !isMarkedForDeletion

  const {
    MAX_COMPLEX_QUERY_COUNT: defaultMaxComplexQueryCount,
    MAX_TIMER_QUERY_COUNT: defaultMaxTimerQueryCount,
  } = MAX_MODULE_COUNTS[moduleType]
  const MAX_COMPLEX_QUERY_COUNT =
    typeof moduleCapacity.maxLogic === 'number' &&
    Number.isFinite(moduleCapacity.maxLogic) &&
    moduleCapacity.maxLogic > 0
      ? moduleCapacity.maxLogic
      : defaultMaxComplexQueryCount
  const MAX_TIMER_QUERY_COUNT =
    typeof moduleCapacity.maxTimer === 'number' &&
    Number.isFinite(moduleCapacity.maxTimer) &&
    moduleCapacity.maxTimer > 0
      ? moduleCapacity.maxTimer
      : defaultMaxTimerQueryCount

  if (isOverQueryCount && isOverTimerCount) {
    const displayFn = canUpgrade
      ? strings.cannot_update_reason_both
      : strings.cannot_add_back_reason_both

    return displayFn(
      displayName,
      MAX_COMPLEX_QUERY_COUNT,
      MAX_TIMER_QUERY_COUNT
    )
  }

  if (isOverQueryCount) {
    const displayFn = canUpgrade
      ? strings.cannot_update_reason_logic_sets
      : strings.cannot_add_back_reason_logic_sets

    return displayFn(displayName, MAX_COMPLEX_QUERY_COUNT)
  }

  if (isOverTimerCount) {
    const displayFn = canUpgrade
      ? strings.cannot_update_reason_timers
      : strings.cannot_add_back_reason_timers

    return displayFn(displayName, MAX_TIMER_QUERY_COUNT)
  }

  return false
}
